import { Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { StorageService } from "@services/storage/storage.service";
import { Util } from "@shared/common/utils/util";
import {
  CODIGO_PARENTESTO_HIJO_O_HIJA,
  HeadersTableBalances,
  HeadersTableBeneficiaries,
} from "@constants/tramite-pension-constant";
import {
  ROUTING_TRAMITE_PENSION_INVALIDEZ
} from "@constants/url.constant";
import { ACCOUNTS, storageTramitePension } from "./personal-data.const";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { MensajeSalidaFlujoTramitePension, TipoMensajeSalidaFlujoTramitePension } from "@constants/business.constant";
import { GtmService } from "@services/gtm/gtm.service";
import { InvalidezStepperService } from "../../service/invalidez-stepper.service";
import { TramitePensionService } from "src/app/tramite-pension/services/tramite-pension.service";
import { DsButtonV2Component, DsCardComponent, DsCheckComponent, DsInlineAlertComponent, DsSkeletonComponent, DsTableColumn, DsTableComponent } from "@customdesignsystem";
import { PiModalMensajeGenericoService } from "../../service/pi-modal-mensaje-generico.service";
import { PiDocumentUploadComponent } from "../../components/pi-document-upload/pi-document-upload.component";


@Component({
  selector: "app-invalidez-personal-data",
  templateUrl: "./invalidez-personal-data.component.html",
  styleUrls: ["./invalidez-personal-data.component.scss"],
  standalone: true,
  imports: [CommonModule, DsCardComponent, DsSkeletonComponent, DsTableComponent, DsCheckComponent, DsButtonV2Component, DsInlineAlertComponent,
    PiDocumentUploadComponent
  ],
  encapsulation: ViewEncapsulation.Emulated
})
export class InvalidezPersonalDataComponent implements OnInit, OnDestroy {
  private requestLayoutHost: HTMLElement | null = null;
  private readonly ACCOUNT_IDS_OBLIGATORIO = ['CCO', 'CAF', 'CAI', 'CDC'];

  personalData: any;
  headerBalances = HeadersTableBalances;
  balances: any[] = [];
  headerBeneficiaries = HeadersTableBeneficiaries;
  beneficiaries: any[] = [];
  btnDisabled = true;
  showErrorEncuesta: boolean = false;
  loadingPersonalData = true;
  dataDropdown: any;
  valueDropdown: number = 0;
  bonos: any[] = [];
  balancesVoluntario: any[] = [];
  aporteEstatalRows: Array<{
    fund: string;
    balanceInstallments: string;
    balancePesos: string;
  }> = [];
  readonly headerAporteEstatal = ["Fondo", "Saldo Cuotas", "Saldo Pesos*"];
  readonly textoAporteEstatalApv =
    "El Estado te bonifica con un 15% del monto total ahorrado y se destina completamente a tu pensión";

  columnsBeneficiarios: readonly DsTableColumn<any>[] = [
    { key: 'nombre', header: 'Nombre', value: (row) => row.nombre },
    { key: 'parentesco', header: 'Parentesco', value: (row) => row.parentesco },
    { key: 'rut', header: 'Rut', value: (row) => row.rut },
  ];

  columnsSaldosObligatorios: readonly DsTableColumn<any>[] = [
    { key: 'product', header: 'Producto', value: (row) => row.product },
    { key: 'fund', header: 'Fondo', value: (row) => row.fund },
    { key: 'balanceInstallments', header: 'Saldo Cuotas', value: (row) => row.balanceInstallments },
    { key: 'balancePesos', header: 'Saldo Pesos', value: (row) => row.balancePesos },
  ];

  rowKeyBeneficiario = (row: { id: string | number }): string | number => row.id;
  rowKeyBalance = (row: { id: string | number }): string | number => row.id;
  checked = false;
  checkCondicionesBeneficiario = false;
  checkCondicionesDatosPersonales = false;
  documentosIncompletos = true;
  loading = false;
  private urlReturnPaso2 = `/${ROUTING_TRAMITE_PENSION_INVALIDEZ.BASE_URL}/${ROUTING_TRAMITE_PENSION_INVALIDEZ.REQUEST}/${ROUTING_TRAMITE_PENSION_INVALIDEZ.DATOS_PERSONALES}`;
  private urlReturnPaso0 = `/${ROUTING_TRAMITE_PENSION_INVALIDEZ.BASE_URL}`;
  loadingBeneficiaries = true;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly util: Util,
    private readonly tramitePension: TramitePensionService,
    private readonly storageService: StorageService,
    private readonly tramiteStepper: InvalidezStepperService,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly gtmService: GtmService,
    private readonly modalService: PiModalMensajeGenericoService

  ) {

  }

  ngOnDestroy(): void {
    this.restoreRequestLayoutHost();
  }

  ionViewWillLeave(): void {
    this.restoreRequestLayoutHost();
  }

  ionViewWillEnter(): void {
    this.applyRequestSingleScrollLayout();
  }

  async ngOnInit() {
    this.tramiteStepper.setStepCurrent(2);
    this.applyRequestSingleScrollLayout();
    const results = await Promise.allSettled([
      this.getPersonalData(),
      this.getBeneficiarios(),
      this.loadBalances(),
    ]);
    for (const result of results) {
      if (result.status === "rejected") {
        console.error("Error al cargar una sección de datos personales", result.reason);
      }
    }
    this.formValueChange();
    this.obtenerFormularioDatosPesonalesStorage();
  }

  get tieneBeneficiariosHijos(): boolean {
    return this.beneficiaries.some(
      (beneficiary) =>
        beneficiary.codigoParentesco === CODIGO_PARENTESTO_HIJO_O_HIJA
    );
  }

  private obtenerFormularioDatosPesonalesStorage() {
    /*let formulario = sessionStorage.getItem(
      STORAGE_FORMULARIO_DATOS_PERSONALES
    );*/
  }

  formValueChange() {
    /*const value = this.form.value;
    const solteriaConfirmada =
      !this.tieneBeneficiariosHijos || value.checkDeclaracionSolteria;

    if (value.checkData && solteriaConfirmada && this.isValidInstitucionSalud()) {
      this.btnDisabled = false;
    } else {
      this.btnDisabled = true;
    }*/
  }

  goBack() {
    this.router.navigate([`../${ROUTING_TRAMITE_PENSION_INVALIDEZ.SEGURIDAD}`], {
      relativeTo: this.activatedRoute,
    });
  }

  async getPersonalData() {
    try {
      const [rut, response] = await Promise.all([
        this.tramitePension.uid(),
        firstValueFrom(this.tramitePension.getPersonalData()),
      ]);
      const date = response?.fechaNacimiento.split("-");
      this.personalData = {
        name: this.util.capitalizeText(response?.nombres),
        lastName: `${this.util.capitalizeText(response?.apellidoPaterno)} ${this.util.capitalizeText(response?.apellidoMaterno)}`,
        rut: this.stringToFormattedRut(rut),
        gender: this.util.capitalizeText(response?.sexo),
        birthDate: `${date[0]}/${date[1]}/${date[2]}`,
        civilStatus: this.util.capitalizeText(response?.estadoCivil),
        address: this.util.capitalizeText(this.validAddress(
          response.direccion,
          response.ciudad,
          response.paisResidencia
        ) || ""),
        phoneNumber: response?.telMovil,
        email: response?.email,
      };
    } catch (error) {
      console.error("Error al obtener el servicio", error);
    } finally {
      this.loadingPersonalData = false;
    }
  }

  validAddress(direccion: string, ciudad: string, pais: string): string | null {
    if (
      direccion === undefined ||
      direccion.trim() === "" ||
      ciudad === undefined ||
      ciudad.trim() === "" ||
      pais === undefined ||
      pais.trim() === ""
    ) {
      return null;
    }
    return `${direccion}, ${ciudad}, ${pais}`;
  }

  async getBeneficiarios(): Promise<void> {
    this.loadingBeneficiaries = true;
    try {
      const response = await firstValueFrom(this.tramitePension.getBeneficiaries());
      this.beneficiaries =
        response?.map((item) => ({
          id: item.idBeneficiario,
          nombre: `${item.apellidoPaterno} ${item.apellidoMaterno}, ${item.nombres}`,
          parentesco: item.parentesco,
          codigoParentesco: item.codigoParentesco,
          rut: this.stringToFormattedRut(item.idBeneficiario),
        })) ?? [];
    } catch (error) {
      console.error("Error al obtener el servicio", error);
      this.beneficiaries = [];
    } finally {
      this.loadingBeneficiaries = false;
      this.formValueChange();
    }
  }

  stringToFormattedRut = (rut: string): string => {
    const removeInitialCeros = Number(rut.slice(0, -1));
    const rutString = removeInitialCeros.toString();
    const rutWithDots = this.formatThousandsWithDots(rutString);
    const rutWithDotsAndDash = `${rutWithDots}-${rut.slice(-1)}`;
    return rutWithDotsAndDash;
  };

  private formatThousandsWithDots(value: string): string {
    if (value.length <= 3) {
      return value;
    }

    const remainder = value.length % 3;
    const prefix = remainder ? `${value.slice(0, remainder)}.` : '';
    const groups = value.slice(remainder).match(/\d{3}/g)?.join('.') ?? '';
    return `${prefix}${groups}`;
  }

  goToYourData() {
    this.redirectToTramitePensionPaso2();
    this.gtmService.trackClick('button', 'Tus datos', 'link_interno', 'modal');
    this.modalService.open(MensajeSalidaFlujoTramitePension[TipoMensajeSalidaFlujoTramitePension.ActualizaDatos]);
  }

  goToYourBeneficiaries() {
    this.redirectToTramitePensionPaso0();
    this.gtmService.trackClick('button', 'Actualizar tus beneficiarios', 'link_interno', 'modal');
    this.modalService.open(MensajeSalidaFlujoTramitePension[TipoMensajeSalidaFlujoTramitePension.Beneficiario]);
  }

  goToVideoAtencion() {
    this.redirectToTramitePensionPaso2();
    this.gtmService.trackClick('button', 'Video atención', 'link_interno', 'modal');
    this.modalService.open(MensajeSalidaFlujoTramitePension[TipoMensajeSalidaFlujoTramitePension.VideoAtencion]);
  }

  goToFundChange() {
    this.redirectToTramitePensionPaso2();
    this.gtmService.trackClick('button', 'Cambio de Fondos', 'link_interno', 'modal');
    this.modalService.open(MensajeSalidaFlujoTramitePension[TipoMensajeSalidaFlujoTramitePension.CambioFondo]);
  }

  private async loadBalances(): Promise<void> {
    const cuentas: any[] = (await this.storageService.get("accounts")) ?? [];
    await this.fillBalanceTable(cuentas);
  }

  async fillBalanceTable(cuentasIniciales?: any[]) {
    const cuentas: any[] = cuentasIniciales ?? (await this.storageService.get("accounts")) ?? [];
    this.balances = this.processBalances(cuentas, this.ACCOUNT_IDS_OBLIGATORIO);
    console.log("this.balances", this.balances);
  }

  private processBalances(cuentas: any[], allowedAccountIds: string[]) {
    if (!cuentas) return [];

    return cuentas
      .filter((balance) =>
        allowedAccountIds.includes(this.getAccountId(balance))
      )
      .flatMap((balance) => {
        const accountId = this.getAccountId(balance);
        const funds = balance.funds ?? [];
        const rows =
          funds.length > 0
            ? funds.map((fund: any) => ({
              product: this.getAccountTitle(accountId),
              fund: `Fondo ${fund.id}`,
              balanceInstallments: this.formatSaldoCuotas(fund.shareBalance),
              balancePesos: this.util.currencyFormat(fund.amount ?? 0),
            }))
            : [
              {
                product: accountId,
                fund: "—",
                balanceInstallments: "—",
                balancePesos: this.util.currencyFormat(balance.amount ?? 0),
              },
            ];

        return rows;
      });
  }

  private getAccountId(balance: any): string {
    return balance.accountConfiguration?.id ?? balance.id ?? "";
  }

  private formatSaldoCuotas(shareBalance: number | string | undefined): string {
    if (shareBalance === null || shareBalance === undefined || shareBalance === "") {
      return "—";
    }
    if (typeof shareBalance === "number") {
      return this.util.currencyFormat(shareBalance);
    }
    return String(shareBalance);
  }

  getAccountTitle(id: string) {
    return ACCOUNTS.find((acc) => acc.value === id)?.title;
  }

  async continue() {
    try {

      //sessionStorage.setItem(STORAGE_FORMULARIO_DATOS_PERSONALES, JSON.stringify(formData));
      this.gtmService.trackClick('button', 'Continuar', 'boton_principal', '/pensions/tramite-pensiones/solicitud/antecedentes-pension');
      await this.router.navigate([`../${ROUTING_TRAMITE_PENSION_INVALIDEZ.ANTECEDENTES_PENSION}`], {
        relativeTo: this.activatedRoute,
      });
    } catch (error) {
      console.error("Error al navegar:", error);
    }
  }
  onChangeDropdown(event: any) {
    this.valueDropdown = event;
    sessionStorage.setItem(storageTramitePension.institucionSalud, event);
    this.formValueChange();
  }
  isValidInstitucionSalud(): boolean {
    return this.valueDropdown !== 0;
  }

  private applyRequestSingleScrollLayout(): void {
    this.requestLayoutHost = this.elementRef.nativeElement.closest(
      "app-tramite-pension-request"
    );
    if (!this.requestLayoutHost) {
      return;
    }
    this.requestLayoutHost.style.setProperty("display", "block");
    this.requestLayoutHost.style.setProperty("height", "100%");
    this.requestLayoutHost.style.setProperty("max-height", "100%");
    this.requestLayoutHost.style.setProperty("min-height", "0");
    this.requestLayoutHost.style.setProperty("overflow", "hidden");
  }

  private restoreRequestLayoutHost(): void {
    if (!this.requestLayoutHost) {
      return;
    }
    this.requestLayoutHost.style.removeProperty("display");
    this.requestLayoutHost.style.removeProperty("height");
    this.requestLayoutHost.style.removeProperty("max-height");
    this.requestLayoutHost.style.removeProperty("min-height");
    this.requestLayoutHost.style.removeProperty("overflow");
    this.requestLayoutHost = null;
  }

  private redirectToTramitePensionPaso2(): void {
    this.tramitePension.clearCache();
    this.storageService.set("redirectTramtitePension", this.urlReturnPaso2);
  }

  private redirectToTramitePensionPaso0(): void {
    this.tramitePension.clearCache();
    this.storageService.set("redirectTramtitePension", this.urlReturnPaso0);
  }
}
